module.exports = __webpack_public_path__ + "11_hige_black.aa12fad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/11_hige_black.png
// module id = Zwdt
// module chunks = 0